export function useTotalPerMonth(offer, category = null, monthlyDiscount= null) {
    const categoryPrice = category ? parseFloat(category) : offer.monthly_price_category;

    let result = parseFloat(offer.subscription.monthly_price_bundle)
        + parseFloat(offer.subscription.monthly_price_minutes)
        + parseFloat(offer.subscription.monthly_price_internet)
        + parseFloat(offer.subscription.monthly_price_sms)
        + parseFloat(categoryPrice)
        + parseFloat(offer.monthly_price_discount);

    if (monthlyDiscount) {
        result += parseFloat(monthlyDiscount);
    }

    if (!offer.subscription.has_device && offer.cash_back) {
        result -= offer.cash_back / offer.subscription.duration
    }

    return result;
}
